<template>
  <div class="badge-wrap" :class="{ lms: $config.project === 'lms', 'text-mode': textMode }">
    <span v-if="textMode" class="text">
      30-Day Money-Back Guarantee
    </span>
    <template v-else>
      <img v-if="!hideMoneyBack && dark && !neutral" src="../assets/images/icon-money-back-dark.png" alt="30 day money back guarantee">
      <img v-else-if="!hideMoneyBack && light && !neutral" src="../assets/images/icon-money-back-light.png" alt="30 day money back guarantee">
      <img v-else-if="!hideMoneyBack" src="../assets/images/icon-money-back.png" alt="30 day money back guarantee">
    </template>
    <div class="price-lock">
      <span v-if="textMode" class="text">
        Price-Lock Guarantee
      </span>
      <template v-else>
        <img v-if="!hidePriceLock && dark && !neutral" src="../assets/images/icon-price-lock-dark.png" alt="Price lock guarantee">
        <img v-else-if="!hidePriceLock && light && !neutral" src="../assets/images/icon-price-lock-light.png" alt="Price lock guarantee">
        <img v-else-if="!hidePriceLock" src="../assets/images/icon-price-lock.png" alt="Price lock guarantee">
      </template>
      <div class="tooltip-holder">
        <Component :is="tooltipIcons[infoIcon]" class="info" />
        <Tooltip class="tooltip">
          The price lock guarantees you'll be charged the amount of your initial subscription on all subsequent automatic renewals. The price won't increase, but further discounts may apply—so look for hidden benefits.
        </Tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from '../components/Tooltip.vue';
import Question from '../assets/svg/icon-question.svg?vue-component';
import Info from '../assets/svg/icon-info.svg?vue-component';

export default {
  components: {
    Question,
    Info,
    Tooltip,
  },
  props: {
    infoIcon: {
      type: String,
      default: 'info',
    },
    hideMoneyBack: Boolean,
    hidePriceLock: Boolean,
    dark: Boolean,
    light: Boolean,
    neutral: Boolean,
    textMode: Boolean,
  },
  data() {
    return {
      tooltipIcons: {
        question: 'Question',
        info: 'Info',
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.badge-wrap {
  margin-top: var(--spacing-20);
  display: flex;
  justify-content: center;
  gap: var(--spacing-20);

  img {
    width: 100px;
    display: block;
  }

  .price-lock {
    position: relative;

    .tooltip-holder {
      position: absolute;
      top: -5px;
      right: 0;

      &:hover .tooltip {
        display: block;
      }

      .tooltip {
        padding: 20px;
        border-radius: 10px;

        &:after {
          transform: translateX(-50%);
        }
      }
    }
  }

  &.billing,
  &.pricing {
    margin-top: 0;

    .price-lock {
      .tooltip-holder {
        .tooltip {
          width: 360px;
          font-size: 16px;
          line-height: 160%;
          backdrop-filter: blur(5px);
          -webkit-backdrop-filter: blur(5px);

          &:after {
            border-left-width: 10px;
            border-right-width: 10px;
            border-top-width: 10px;
          }
        }
      }
    }
  }

  &.billing {
    .price-lock {
      .tooltip-holder {
        .tooltip {
          left: calc(50% - 130px);

          &:after {
            left: calc(50% + 130px);
          }
        }
      }
    }
  }

  &.pricing {
    .price-lock {
      .tooltip-holder {
        .tooltip {
          background: rgba(255, 255, 255, 0.8);
          color: var(--main-dark-shade-0);
          border: 0.691009px solid var(--gray);

          &:after {
            border-top-color: #C4C4C4;
          }
        }
      }
    }
  }

  &.checkout-badges {
    .price-lock {
      .tooltip-holder {
        .tooltip {
          width: 220px;
          padding: var(--spacing-16);
          background: var(--main-light);
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
          border-radius: 3px;
          color: var(--main-dark-shade-0);
          text-align: center;
          font-size: 14px;
          line-height: 140%;
          border: none;

          &:after {
            top: unset;
            bottom: 2px;
            margin-left: -2px;
            height: 15px;
            width: 15px;
            background-color: var(--main-light);
            clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
            transform: rotate(-45deg) translateX(-50%);
            border-radius: 0 0 0 0.25em;
            border-left: none;
            border-right: none;
            border-top: none;
          }
        }
      }
    }
  }
}

@include bp($bp-laptop) {
  .badge-wrap.pricing .price-lock .tooltip-holder .tooltip {
    font-size: 14px;
  }
}

@include bp($bp-mobile) {
  .badge-wrap {
    margin-top: var(--spacing-40);

    &.pricing {
      .price-lock {
        .tooltip-holder {
          .tooltip {
            width: 300px;
            left: calc(50% - 80px);

            &:after {
              left: calc(50% + 80px);
            }
          }
        }
      }
    }

    &.billing {
      margin-top: 0;

      .price-lock {
        .tooltip-holder {
          .tooltip {
            width: 300px;
            left: calc(50% - 100px);

            &:after {
              left: calc(50% + 100px);
            }
          }
        }
      }
    }

    &.checkout-badges {
      .price-lock .tooltip-holder {
        .tooltip {
          left: -50px;

          &:after {
            left: calc(50% + 58px);
          }
        }
      }
    }
  }
}
</style>
